import { render, staticRenderFns } from "./DocumentationToc.vue?vue&type=template&id=1ec041b8&scoped=true&"
import script from "./DocumentationToc.vue?vue&type=script&lang=js&"
export * from "./DocumentationToc.vue?vue&type=script&lang=js&"
import style0 from "./DocumentationToc.vue?vue&type=style&index=0&id=1ec041b8&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ec041b8",
  null
  
)

export default component.exports